module.exports = __webpack_public_path__ + "media/src/assets/images/amenities_blue/free_wifi-f1a392c788cfa1c3fedb66ae8d0680ff.svg";